import React from "react";

const IconMoreKebab = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="6"
      height="22"
      viewBox="0 0 6 22"
    >
      <g id="more-vertical-angular" transform="translate(0.534 0.312)">
        <rect
          id="Rectangle_1029"
          dataname="Rectangle 1029"
          width="5"
          height="5"
          rx="2"
          transform="translate(-0.034 0.188)"
          fill="none"
          stroke="#828080"
          strokeMiterlimit="10"
          strokeWidth="1"
        />
        <rect
          id="Rectangle_1030"
          dataname="Rectangle 1030"
          width="5"
          height="5"
          rx="2"
          transform="translate(-0.034 8.188)"
          fill="none"
          stroke="#828080"
          strokeMiterlimit="10"
          strokeWidth="1"
        />
        <rect
          id="Rectangle_1031"
          dataname="Rectangle 1031"
          width="5"
          height="5"
          rx="2"
          transform="translate(-0.034 16.188)"
          fill="none"
          stroke="#828080"
          strokeMiterlimit="10"
          strokeWidth="1"
        />
      </g>
    </svg>
  );
};

export default IconMoreKebab;
